module.exports = __webpack_public_path__ + "static/img/readIn.ae107cf3.png";